<template>
    <div class="w-full  md:pt-12 text-main-text  ">
        <table class="w-full h-full relative">
            <thead>
            <tr class="md:border-b md:w-full">
                <th class="invisible w-6 md:w-8"></th>
                <th v-if="!mobile" class="invisible md:w-8"></th>
                <th class=" text-10px md:text-sm">№</th>
                <th class="w-64 md:w-1/2 text-10px md:text-sm">Название команды</th>
                <th v-if="!mobile"><p class="">К оплате</p></th>
                <th><p class="text-center md:text-left text-10px md:text-sm md:w-16">Кол-во <br class="md:hidden"> игроков </p></th>
                <th v-if="!mobile&&isCorpLeague"><p class="">Логотип</p></th>
                <th v-if="!mobile&&!isCorpLeague">Комментарий</th>
                <th v-if="!mobile"></th>

            </tr>
            </thead>
            <tbody v-for="(registration, id, key) in registration_date_main" :key="Math.random()*100">
                <registration-line v-for="(registration_line, team_number) in registration"
                :event="event"
                                  ref="registration"
                                  :downloadImages="downloadImages"
                                   :events="events"
                                   :checkedLine="checkedLine"
                                   @addSelectedLine="addSelectedLine"
                                   :registration="registration_line" :key="Math.random()*100" :team_number="team_number" :type="id" :team_count="key"></registration-line>

            </tbody>
            <tbody v-for="(registration, id, key) in registration_date_reserv" :key="Math.random()*100">
                <registration-line v-for="(registration_line, team_number) in registration"
                                  :event="event"
                                  :downloadImages="downloadImages"
                                  ref="registration"
                                   :events="events"
                                   :checkedLine="checkedLine"
                                   @addSelectedLine="addSelectedLine"
                                   :registration="registration_line" :key="Math.random()*100" :team_number="team_number" :type="id" :team_count="key"></registration-line>

            </tbody>

        </table>
         <modal :application_adding="true" :max_width="775" class="overlay"  v-if="newComand" :click-outside="false">
            <new-registration-modal
                        :opened_from="'registration-data'"
                        :event_price="event.price"
                        :eventId="event.uuid"
                        @close="newComand = false"
                        :isCorpLeague="isCorpLeague"
                        @saved="newComand = false; $emit('update')"
                ></new-registration-modal>
         </modal>
            <div v-if="event.is_registration_opened" class="w-full flex justify-start pt-10 md:pl-8 pl-1 cursor-pointer" >
                <div @click="createTeam" class="flex flex-row items-center w-48">
                    <div class="rounded-full flex flex-row justify-center items-center w-8 h-8
                outline-none bg-additional-text">
                        <font-awesome-icon class="text-white text-xl" :icon="['fal', 'plus']"></font-awesome-icon>
                    </div>
                    <p class="ml-3 text-10px md:text-sm font-bold text-additional-text">Добавить команду</p>
                </div>
            </div>
    </div>
</template>

<script>
import RegistrationLine from './registration-line';
import NewRegistrationModal from './new-registration-modal.vue';
import client from '@/clients/partners';
import Form from 'form-backend-validation';
import Modal from '@/views/modals/base-modal';
import OnClickOutside from '@/views/OnClickOutside';

export default {
  name: 'registration-data',
  components: {
    OnClickOutside, RegistrationLine, Form, NewRegistrationModal, Modal,
  },
  props: ['registration_date', 'events', 'event', 'downloadImages'],
  data() {
    return {
      newComand: false,
      show_deleted_teams: false,
      checkedLine: [
        { ids: [], status: '' },
      ],
    };
  },

  methods: {
    addSelectedLine(lineId, isDelete, lineType) {
      if (this.checkedLine[0].status && this.checkedLine[0].status === lineType) {
        let isRepeat = false;

        for (const i in this.checkedLine[0].ids) {
          if (this.checkedLine[0].ids[i] === lineId) {
            isRepeat = true;
          }
          if (this.checkedLine[0].ids[i] === lineId && isDelete) {
            this.checkedLine[0].ids.splice(i, 1);
          }
        }
        if (!isRepeat) {
          this.checkedLine[0].ids.push(lineId);
        }
      } else if (this.checkedLine[0].status !== '' && this.checkedLine[0].status !== lineType) {
        this.clearSelectedLine();


        this.checkedLine[0].status = lineType;
      }
      if (!this.checkedLine[0].status) {
        this.checkedLine[0].ids.push(lineId);
        this.checkedLine[0].status = lineType;
      }
      if (this.checkedLine[0].ids.length === 0) {
        this.checkedLine[0].status = '';
      } else {


      }
      this.$emit('addParams', this.checkedLine[0]);
    },
    createTeam() {
      if (this.mobile) {
        this.$router.push({
          name: 'new-team-mobile',
          params: {
            isCorpLeague: this.isCorpLeague, eventId: this.event.uuid, price: this.event.price, opened_from: 'registration-data',
          },
        });
      } else {
        this.newComand = true;
      }
    },
    clearSelectedLine() {
      this.checkedLine = [
        { ids: [], status: '' },
      ];
    },
    restoreCheckedLine() {
      this.checkedLine = [
        { ids: [], status: '' },
      ];
      if (this.$refs.registration) {
        this.$refs.registration.forEach(item => item.uncheck());
        this.$emit('addParams', this.checkedLine[0]);
      }
    },
  },
  computed: {
    mobile() {
      return window.innerWidth < 840;
    },
    rotateArrow() {
      return !this.show_deleted_teams ? '' : 'rotate-arrow';
    },

    registration_date_main() {
      const date = {};
      Object.keys(this.registration_date).forEach((item) => {
        if (item === 'cancelled' || item === 'reserve') return;
        date[item] = this.registration_date[item];
      });
      return date;
    },
    registration_date_reserv() {
      const date = {};
      Object.keys(this.registration_date).forEach((item) => {
        if (item !== 'reserve') return;
        date[item] = this.registration_date[item];
      });
      return date;
    },
    isCorpLeague() {
      return this.event.product.toLowerCase().includes('корпоративная лига');
    },
  },
};
</script>

<style scoped>
    th {
        @apply text-left whitespace-no-wrap bg-white font-sans text-sm whitespace-no-wrap pb-2;
    }

    .arrow {
        transition: 0.5s all;
    }

    .rotate-arrow {
        transform: rotate(180deg);
    }

    .copy-icon-class {
        width: 2.24rem;
        height: 2.2rem;
        border-radius: 100%;
        background-color: #e7e7e7;
    }
</style>
